// @ts-nocheck
import PropTypes from "prop-types";
import React from "react";
import { useDateFormat } from "../../../hooks/useDateFormat";
import className from "./PulldownList.module.scss";
import PullDownItem from "./PullDownItem";
import PullDownItemGroup from "./PullDownItemGroup";
import { useTranslation } from "react-i18next";

export const DatePulldownList = ({
  date,
  date_format,
  month,
  month_format,
  onClickList,
  isSuggestClose,
  disable_suggest_date_types,
}) => {
  const { t } = useTranslation();

  return (
    <div className={className.pulldownScroll} style={{ margin: "0 12px" }}>
      {Object.entries(date).map(([key, value]) => (
        <PullDownItemGroup key={key} title={value} image="">
          {date_format.map((format) => (
            <PullDownItem
              key={format}
              value={`${key}_${format}`}
              onClick={(e) => {
                onClickList(e, {
                  test_value: useDateFormat(key, format),
                  display_name: `${key}_${format}`,
                });
              }}
            >
              <dl className={className.outputDisplay}>
                <dt className={className.outputTitle}>{format}</dt>
                <dd className={className.outputDescription}>{useDateFormat(key, format)}</dd>
              </dl>
            </PullDownItem>
          ))}
        </PullDownItemGroup>
      ))}
      {(disable_suggest_date_types === undefined || !disable_suggest_date_types.includes("month")) && (
        <>
          {Object.entries(month).map(([key, value]) => (
            <PullDownItemGroup key={key} title={value} image="">
              {month_format.map((format) => (
                <PullDownItem
                  key={format}
                  value={`${key}_${format}`}
                  onClick={(e) => {
                    onClickList(e, {
                      test_value: useDateFormat(key, format),
                      display_name: `${key}_${format}`,
                    });
                  }}
                >
                  <dl className={className.outputDisplay}>
                    <dt className={className.outputTitle}>{format}</dt>
                    <dd className={className.outputDescription}>{useDateFormat(key, format)}</dd>
                  </dl>
                </PullDownItem>
              ))}
            </PullDownItemGroup>
          ))}
        </>
      )}
    </div>
  );
};

DatePulldownList.propTypes = {
  date: PropTypes.object.isRequired,
  date_format: PropTypes.arrayOf(PropTypes.string).isRequired,
  month: PropTypes.object.isRequired,
  month_format: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClickList: PropTypes.func,
  isSuggestClose: PropTypes.bool,
  disable_suggest_date_types: PropTypes.arrayOf(PropTypes.string),
};
